import { api } from "./api";
import { getApiOrganizationId } from "../utils/orgIdUtils";

export type Customer = {
  id: string;
  emailId: string;
  outletName: string;
  status?: "active" | "lapsed" | "inactive" | string;
  createdAt?: any;
  phoneNumber?: string;
  assignedSalesRep?: {
    userId: string;
    salesRep: {
      email: string;
      name: string;
    };
  } | null;
};

export const getCustomersAPI = async (
  search = "",
  page = 1,
  limit = 9999,
  assignment?: string
) => {
  try {
    const params: any = { search, page, limit };

    if (assignment && assignment !== "all") {
      params.filter = assignment;
    }

    const response = await api.get("/get-customers", {
      params,
      headers: {
        orgId: getApiOrganizationId(),
      },
    });

    // Handle the actual API response structure: {"message": "...", "data": {"customers": [...], "totalRecords": 3, "totalPages": 1}}
    const apiData = response.data?.data || response.data;

    if (!apiData) {
      return { customers: [], totalRecords: 0, totalPages: 0 };
    }

    const customers = apiData.customers ?? [];
    const totalRecords = apiData.totalRecords ?? 0;
    const totalPages = apiData.totalPages ?? 1;

    console.log("getCustomersAPI - parsed data:", {
      customers: customers.length,
      totalRecords,
      totalPages,
    });

    return {
      customers: customers.map((c: Customer) => ({
        ...c,
        outletName: (c.outletName ?? "").trim(),
      })),
      totalRecords,
      totalPages,
    };
  } catch (error) {
    console.error("Error fetching customers", error);
    return { customers: [], totalRecords: 0, totalPages: 0 };
  }
};

export type ServiceExciseCustomer = {
  clientCode?: string;
  outletName?: string;
  companyGSTNumber?: string;
  companyPANNumber?: string;
  licenseName?: string;
  licenseGSTNumber?: string;
  licensePANNumber?: string;
};

export const getCustomersServiceExciseAPI = async (
  search = ""
): Promise<ServiceExciseCustomer[]> => {
  try {
    const response = await api.get("/get-customers", {
      params: { search, limit: 9999 },
      headers: {
        orgId: getApiOrganizationId(),
      },
    });

    // Handle actual API response structure
    const apiData = response.data?.data || response.data;

    if (!apiData || !apiData.customers) return [];

    const list = apiData.customers as any[];

    console.log("Fetched Service & Excise customers:", list);

    return list.map((c) => ({
      clientCode: c.clientCode ?? "",
      outletName: (c.outletName ?? "").trim(),
      companyGSTNumber: c.companyGSTNumber ?? "",
      companyPANNumber: c.companyPANNumber ?? "",
      licenseName: c.Address?.licenseName ?? "",
      licenseGSTNumber: c.Address?.licenseGSTNumber ?? "",
      licensePANNumber: c.Address?.licensePANNumber ?? "",
    }));
  } catch (error) {
    console.error("Error fetching Service & Excise customers", error);
    return [];
  }
};

export const getCustomersForDashboardAPI = async (search = "") => {
  try {
    const response = await api.get("/get-customers", {
      params: { search, page: 1, limit: 9999 },
      headers: {
        orgId: getApiOrganizationId(),
      },
    });

    const raw = response.data;

    const customers =
      raw?.data?.customers ??
      raw?.data?.body?.data?.customers ??
      raw?.customers ??
      [];

    const pagination = raw?.data?.pagination ?? raw?.pagination ?? {};

    return {
      customers: customers.map((c: Customer) => ({
        ...c,
        outletName: (c.outletName ?? "").trim(),
      })),
      totalRecords:
        raw?.data?.totalRecords ?? pagination?.totalRecords ?? customers.length,
      totalPages: raw?.data?.totalPages ?? pagination?.totalPages ?? 1,
    };
  } catch (error) {
    console.error("Error fetching dashboard customers", error);
    return { customers: [], totalRecords: 0, totalPages: 0 };
  }
};
